// React
import React from 'react';
import { Row, Col, CardBody, Label, Input } from 'reactstrap';

// Containers
import {
  Currency,
  SelectInput,
  convertEventSelectToTarget,
} from '../../../../containers/componentsInjection';

// Components (Local)
import { ProposalDependentsSection } from './components/proposalDependentsSection';

// Utils
import { createData } from '../../../../../../utils/createData';

export const ProposalDataTab = ({
  plans,
  offices,
  kinships,
  validation,
  dependents,
  maxDependents,
  categoryPlans,
  organizations,
  setDependents,
  showEmployment,
  showOrganization,
  situationOptions,
  departmentOptions,
  preProposalByHash,
  isValidDependentCpf,
  setIsValidDependentCpf,
  paymentFrequencyOptions,
  paymentConditionsOptions,
  isAnyDependentFieldRequired,
  handleChangeCategoryPlanInput,
  setIsAnyDependentFieldRequired,
}) => {
  const resetPlanInput = () => {
    if (validation.values.plan) {
      validation.handleChange({
        target: {
          name: 'plan',
          value: null,
        },
      });
    }
  };

  const resetDepartmentInput = () => {
    if (validation.values.department) {
      validation.handleChange({
        target: {
          name: 'department',
          value: null,
        },
      });
    }
  };

  /**
   * function to create custom data for select input
   * based on data passing as props and search for id
   */
  const createDataById = (data, id) => {
    let newData = data.map((item) => {
      if (item.plan_category_id === id) {
        return {
          value: item.id,
          label: item.name,
        };
      }
    });

    return newData.filter(Boolean);
  };

  return (
    <React.Fragment>
      <CardBody className="border-bottom border-bottom-dashed p-4">
        <Row>
          <Col md={12}>
            <Col md={12} className="mb-4">
              <h4 className="mb-1">{preProposalByHash?.customer_name}</h4>
              <p className="text-muted mb-0">
                {preProposalByHash?.cpf?.replace(
                  /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
                  '$1.$2.$3-$4'
                )}
              </p>
            </Col>

            <Row>
              <Col md={3} className="mb-3">
                <Label for="categoryPlan" className="form-label">
                  Categoria do plano
                </Label>
                <SelectInput
                  options={createData(categoryPlans)}
                  name="categoryPlan"
                  className="form-control bg-light border-0"
                  value={validation.values.categoryPlan}
                  onChange={(e) => {
                    handleChangeCategoryPlanInput(e);
                    resetPlanInput();
                  }}
                  onBlur={(eventInput) => {
                    validation.handleBlur(
                      convertEventSelectToTarget('categoryPlan', eventInput)
                    );
                  }}
                  inputId="categoryPlan"
                  invalid={
                    !!(
                      validation.touched.categoryPlan &&
                      validation.errors.categoryPlan
                    )
                  }
                />
              </Col>

              <Col md={3} className="mb-3">
                <Label for="plan" className="form-label">
                  Plano
                </Label>
                <SelectInput
                  isDisabled={!validation.values.categoryPlan?.value}
                  value={validation.values.plan}
                  className="form-control bg-light border-0"
                  onChange={(eventInput) => {
                    validation.handleChange(
                      convertEventSelectToTarget('plan', eventInput)
                    );
                  }}
                  onBlur={(eventInput) => {
                    validation.handleBlur(
                      convertEventSelectToTarget('plan', eventInput)
                    );
                  }}
                  options={createDataById(
                    plans,
                    validation.values.categoryPlan?.value
                  )}
                  inputId="plan"
                  invalid={
                    !!(validation.touched.plan && validation.errors.plan)
                  }
                />
              </Col>

              <Col md={2} className="mb-3">
                <div>
                  <Label for="saleAt" className="form-label">
                    Data da Venda
                  </Label>
                  <Input
                    className="form-control bg-light border-0"
                    type="date"
                    id="saleAt"
                    name="saleAt"
                    value={validation.values.saleAt}
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    invalid={
                      !!(validation.touched.saleAt && validation.errors.saleAt)
                    }
                  />
                </div>
              </Col>

              <Col md={2} className="mb-3">
                <div>
                  <Label for="effectiveDate" className="form-label">
                    Data da Vigência
                  </Label>
                  <Input
                    className="form-control bg-light border-0"
                    type="date"
                    id="effectiveDate"
                    value={validation.values.effectiveDate}
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    invalid={
                      !!(
                        validation.touched.effectiveDate &&
                        validation.errors.effectiveDate
                      )
                    }
                  />
                </div>
              </Col>

              <Col md={2} className="mb-3">
                <Label for="validUntil" className="form-label">
                  Data da Renovação
                </Label>
                <Input
                  className="form-control bg-light border-0"
                  type="date"
                  id="validUntil"
                  value={validation.values.validUntil}
                  onBlur={validation.handleBlur}
                  onChange={validation.handleChange}
                  invalid={
                    !!(
                      validation.touched.validUntil &&
                      validation.errors.validUntil
                    )
                  }
                />
              </Col>

              {showOrganization && (
                <>
                  <Col md={6} className="mb-3">
                    <Label for="organization" className="form-label">
                      Organização
                    </Label>
                    <SelectInput
                      options={createData(organizations)}
                      value={validation.values.organization}
                      name="organization"
                      isClearable
                      onChange={(eventInput) => {
                        resetDepartmentInput();

                        validation.handleChange(
                          convertEventSelectToTarget('organization', eventInput)
                        );
                      }}
                      onBlur={(eventInput) => {
                        validation.handleBlur(
                          convertEventSelectToTarget('organization', eventInput)
                        );
                      }}
                      className="form-control bg-light border-0"
                      inputId="organization"
                    />
                  </Col>

                  <Col md={6} className="mb-3">
                    <Label for="department" className="form-label">
                      Lotação
                    </Label>

                    <SelectInput
                      isDisabled={!validation.values.organization?.value}
                      inputId="department"
                      className="form-control bg-light border-0"
                      options={departmentOptions}
                      value={validation.values.department}
                      onChange={(eventInput) => {
                        validation.handleChange(
                          convertEventSelectToTarget('department', eventInput)
                        );
                      }}
                      onBlur={(eventInput) => {
                        validation.handleBlur(
                          convertEventSelectToTarget('department', eventInput)
                        );
                      }}
                    />
                  </Col>

                  <Col className="mb-3" md={4}>
                    <Label for="secretary" className="form-label">
                      Secretaria
                    </Label>
                    <Input
                      className="form-control bg-light border-0"
                      type="text"
                      id="secretary"
                      name="secretary"
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                      value={validation.values.secretary}
                    />
                  </Col>
                </>
              )}

              {showEmployment && (
                <>
                  <Col md={4} className="mb-3">
                    <Label for="situation" className="form-label">
                      Situação cadastral
                    </Label>
                    <SelectInput
                      value={validation.values.situation}
                      isClearable
                      className="form-control bg-light border-0"
                      name="situation"
                      onChange={(eventInput) => {
                        validation.handleChange(
                          convertEventSelectToTarget('situation', eventInput)
                        );
                      }}
                      onBlur={(eventInput) => {
                        validation.handleBlur(
                          convertEventSelectToTarget('situation', eventInput)
                        );
                      }}
                      options={situationOptions}
                      inputId="situation"
                    />
                  </Col>

                  <Col className="mb-3" md={4}>
                    <Label for="validContractWork" className="form-label">
                      Vencimento Contrato de Trabalho
                    </Label>
                    <Input
                      className="form-control bg-light border-0"
                      type="date"
                      id="validContractWork"
                      name="validContractWork"
                      value={validation.values.validContractWork}
                      onBlur={validation.handleBlur}
                      onChange={validation.handleChange}
                    />
                  </Col>

                  <Col md={4} className="mb-3">
                    <Label for="registration" className="form-label">
                      Matrícula
                    </Label>
                    <Input
                      className="form-control bg-light border-0"
                      type="text"
                      id="registration"
                      name="registration"
                      value={validation.values.registration}
                      onBlur={validation.handleBlur}
                      onChange={(e) => validation.handleChange(e)}
                      invalid={
                        !!(
                          validation.touched.registration &&
                          validation.errors.registration
                        )
                      }
                    />
                  </Col>
                </>
              )}

              <Col md={12} className="mb-3">
                <Label for="obs" className="form-label">
                  Observações
                </Label>
                <Input
                  className="form-control bg-light border-0"
                  aria-multiline
                  type="textarea"
                  id="obs"
                  style={{
                    height: 100,
                  }}
                  value={validation.values.obs}
                  onBlur={validation.handleBlur}
                  onChange={(e) => validation.handleChange(e)}
                />
              </Col>

              <Col className="mb-3">
                <Input
                  className="me-2"
                  type="checkbox"
                  id="funeralAssistance"
                  name="funeralAssistance"
                  value={validation.values.funeralAssistance}
                  checked={validation.values.funeralAssistance}
                  onBlur={validation.handleBlur}
                  onChange={(e) => validation.handleChange(e)}
                />
                <Label for="funeralAssistance" className="form-label">
                  Assistência funerária
                </Label>
              </Col>
            </Row>

            <Col className="mb-3" md={4}>
              <Label
                for="offices"
                className="text-muted text-uppercase fw-semibold"
              >
                Escritório
              </Label>
              <SelectInput
                inputId="offices"
                className="form-control bg-light border-0"
                options={createData(offices)}
                value={validation.values.offices}
                onChange={(eventInput) => {
                  validation.handleChange(
                    convertEventSelectToTarget('offices', eventInput)
                  );
                }}
                onBlur={(eventInput) => {
                  validation.handleBlur(
                    convertEventSelectToTarget('offices', eventInput)
                  );
                }}
                invalid={
                  !!(validation.touched.offices && validation.errors.offices)
                }
              />
            </Col>
          </Col>
        </Row>
      </CardBody>

      <CardBody className="border-bottom border-bottom-dashed p-4">
        <Row>
          <Col md={12}>
            <Col md={12} className="mb-4">
              <h4 className="mb-1">Forma de Pagamento</h4>
            </Col>

            <Row>
              <Col md={4} className="mb-3">
                <Label for="paymentFrequency" className="form-label">
                  Periodicidade de pagamento
                </Label>
                <SelectInput
                  value={validation.values.paymentFrequency}
                  className="form-control bg-light border-0"
                  name="paymentFrequency"
                  onChange={(eventInput) => {
                    validation.handleChange(
                      convertEventSelectToTarget('paymentFrequency', eventInput)
                    );
                  }}
                  onBlur={(eventInput) => {
                    validation.handleBlur(
                      convertEventSelectToTarget('paymentFrequency', eventInput)
                    );
                  }}
                  options={paymentFrequencyOptions}
                  inputId="paymentFrequency"
                  invalid={
                    !!(
                      validation.touched.paymentFrequency &&
                      validation.errors.paymentFrequency
                    )
                  }
                />
              </Col>

              <Col md={4} className="mb-3">
                <Label for="paymentConditions" className="form-label">
                  Condições de pagamento
                </Label>
                <SelectInput
                  value={validation.values.paymentConditions}
                  name="paymentConditions"
                  className="form-control bg-light border-0"
                  isClearable={false}
                  onChange={(eventInput) => {
                    validation.handleChange(
                      convertEventSelectToTarget(
                        'paymentConditions',
                        eventInput
                      )
                    );
                  }}
                  onBlur={(eventInput) => {
                    validation.handleBlur(
                      convertEventSelectToTarget(
                        'paymentConditions',
                        eventInput
                      )
                    );
                  }}
                  options={paymentConditionsOptions}
                  inputId="paymentConditions"
                  invalid={
                    !!(
                      validation.touched.paymentConditions &&
                      validation.errors.paymentConditions
                    )
                  }
                />
              </Col>

              <Col md={3} className="mb-3">
                <Label for="price" className="form-label">
                  Preço
                </Label>
                <Currency
                  className="form-control bg-light border-0"
                  value={Number(validation.values.price || 0)}
                  onChange={(_, eventInputWithoutMask) => {
                    validation.handleChange(
                      convertEventSelectToTarget('price', eventInputWithoutMask)
                    );
                  }}
                  onBlur={(_, eventInputWithoutMask) => {
                    validation.handleBlur(
                      convertEventSelectToTarget('price', eventInputWithoutMask)
                    );
                  }}
                  id="price"
                  name="price"
                  invalid={
                    !!(validation.touched.price && validation.errors.price)
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>

      <ProposalDependentsSection
        kinships={kinships}
        dependents={dependents}
        maxDependents={maxDependents}
        setDependents={setDependents}
        isValidDependentCpf={isValidDependentCpf}
        setIsValidDependentCpf={setIsValidDependentCpf}
        initialDependents={preProposalByHash?.dependents}
        isAnyDependentFieldRequired={isAnyDependentFieldRequired}
        setIsAnyDependentFieldRequired={setIsAnyDependentFieldRequired}
      />

      <CardBody className="p-4">
        <Row>
          <Col md={4}>
            <Col md={12} className="mb-4">
              <h4 className="mb-1">Foto do Associado</h4>

              <img
                id="customerPhoto"
                name="customerPhoto"
                className="img-thumbnail"
                alt="foto do associado"
                width="200"
                src={validation.values.customerPhoto}
              ></img>
            </Col>
          </Col>

          <Col md={4}>
            <Col md={12} className="mb-4">
              <h4 className="mb-1">Documento com foto</h4>

              <img
                id="docPhoto"
                name="docPhoto"
                className="img-thumbnail"
                alt="documento com foto"
                width="200"
                src={validation.values.docPhoto}
              ></img>
            </Col>
          </Col>

          <Col md={4}>
            <Col md={12} className="mb-4">
              <h4 className="mb-1">Assinatura</h4>

              <img
                id="signature"
                name="signature"
                className="img-thumbnail"
                alt="assinatura"
                width="200"
                src={validation.values.signature}
              ></img>
            </Col>
          </Col>
        </Row>
      </CardBody>
    </React.Fragment>
  );
};
